module.exports = __webpack_public_path__ + "img/icon_jczd.30dbfb48.png";